// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e776c69e","977":"0bb7b6b7"}[chunkId] + ".chunk.js";
};